import * as React from "react";
import { AiFillHeart } from "react-icons/ai";

const Footer = () => {
  return (
    <div className="flex flex-row justify-center items-center w-full pt-4">
      <div className="flex flex-row justify-center items-center pb-5">
        <p className="mr-2">Fait main avec</p>
        <AiFillHeart className="animate-pulse" color="red" />
        <p className="ml-2">par Natacha Rome</p>
      </div>
    </div>
  );
};

export default Footer;
